const NoLayout = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default NoLayout;
